<div class="text-sm text-red {{ classNames }}">
  <ng-content></ng-content>
</div>
